var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contend"}},[_c('topbar'),_c('div',{attrs:{"id":"dash"}},[_c('dashboard')],1),_c('div',{attrs:{"id":"menu"}},[_c('menusis')],1),_c('div',{attrs:{"id":"relatorios"}},[_c('relatorios')],1),_c('div',{attrs:{"id":"perfil"}},[_c('perfil')],1),_c('footernav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }